import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormService } from 'app/services/form.service';

@Component({
  selector: 'app-trivial-names',
  templateUrl: './trivial-names.component.html',
  styleUrls: ['./trivial-names.component.scss']
})
export class TrivialNamesComponent implements OnInit {
  @ViewChild('trivialNamesInput') trivialNamesInput!: ElementRef;
  trivialNames!: string;
  formType !: string;

  constructor(private formService: FormService) {}

  ngOnInit(): void {
    this.trivialNames = this.currentForm.get('trivialNames')?.value;
    this.formType = this.currentForm.get('formType')?.value;
  }

  public clearTrivialNamesInputField() {
    this.trivialNames = '';
    this.currentForm.patchValue({'trivialNames': ''});
  }

  public updateTrivialNames(event: Event) {
    if(event && event.type === 'blur') {
      var target = document.activeElement;
      if(target && target.nodeValue === "cancel") {
        this.trivialNames = '';
      }
    }
    this.currentForm.patchValue({'trivialNames': this.trivialNames});
  }

  public cancelUpdate() {
    this.trivialNames = this.currentForm.get('trivialNames')?.value;
  }

  get currentForm(): FormGroup {
    return this.formService.getCurrentUsanFormValue();
  }

}
